import React from 'react';

import createIcon from './createIcon';

export default createIcon(
  '0 0 14 14',
  <path d="M10.6686 2.00228H10.002V0.668945H8.66862V2.00228H3.33529V0.668945H2.00195V2.00228H1.33529C0.595286 2.00228 0.00861979 2.60228 0.00861979 3.33561L0.00195312 12.6689C0.00195312 13.4023 0.595286 14.0023 1.33529 14.0023H10.6686C11.402 14.0023 12.002 13.4023 12.002 12.6689V3.33561C12.002 2.60228 11.402 2.00228 10.6686 2.00228ZM10.6686 12.6689H1.33529V5.33561H10.6686V12.6689ZM2.66862 6.66895H6.00195V10.0023H2.66862V6.66895Z"/>
,
);
